/* eslint-disable no-implicit-coercion */
export const NETOP_PORTAL_ENVIRONMENT = process.env.REACT_APP_PORTAL_ENVIRONMENT
export const NETOP_PORTAL_URL = process.env.REACT_APP_PORTAL_URL
export const NETOP_PORTAL_API_URL = process.env.REACT_APP_PORTAL_API_URL
export const NETOP_ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL
export const NETOP_AGENT_URL = process.env.REACT_APP_AGENT_URL
export const FEATURE_AUDIO_CHAT = process.env.REACT_APP_FEATURE_AUDIO_CHAT
export const LOGGER = process.env.REACT_APP_LOGGER
export const FEATURE_DYNAMIC_TURN_AUTH = !!+process.env.REACT_APP_FEATURE_DYNAMIC_TURN_AUTH
export const FEATURE_CLIPBOARD_SYNCHRONIZATION = !!+process.env.REACT_APP_FEATURE_CLIPBOARD_SYNCHRONIZATION

export const getPortalGetInfoUrl = () => {
  if (NETOP_PORTAL_ENVIRONMENT === 'development') {
    return `${NETOP_PORTAL_API_URL}/portal/v2/getInfo`
  }
  return `${NETOP_PORTAL_URL}/portal/v2/getInfo`
}

export const getPortalGetAccount = () => {
  return `${NETOP_PORTAL_API_URL}/v4/rpc/get-current-account`
}
